import { getYear } from 'date-fns';

import { useAssets } from '@labradorsports/assets';

const Footer: FC = () => {
    const { FooterLogo, InstagramLogoWhite, FacebookLogoWhite, YouTubeLogoWhite, TwitterLogoWhite } = useAssets();

    return (
        <section className="footer">
            <div className="footer-top-section">
                <div>
                    <p>
                        <a href="https://labradorsports.com/basketball/">Hoops Lab</a>
                    </p>
                    <p>
                        <a href="https://labradorsports.com/basketball-features/">Features</a> |{' '}
                        <a href="https://labradorsports.com/basketball-pricing/">Pricing</a>
                    </p>
                </div>
                <div className="footer-logo">
                    <img src={FooterLogo} alt="" />
                </div>
                <div className="text-end">
                    <p>
                        <a href="https://labradorsports.com/lacrosse">Lacrosse Lab</a>
                    </p>
                    <p>
                        <a href="https://labradorsports.com/lacrosse-features/">Features</a> |{' '}
                        <a href="https://labradorsports.com/lacrosse-pricing/">Pricing</a>
                    </p>
                </div>
            </div>

            <div className="text-center">
                <div>
                    <p>
                        <a href="https://labradorsports.com/">Labrador Sports Home</a>&nbsp;|&nbsp;
                        <a href="https://labradorsports.com/about-us/">About Us</a>
                    </p>
                </div>
                <div>
                    <p>
                        <a href="https://app.termly.io/document/terms-of-use-for-saas/3e7f14b7-2cec-45f4-a500-d8c920b9036f">
                            Terms of Use
                        </a>{' '}
                        |{' '}
                        <a href="https://app.termly.io/document/privacy-policy/ab968f56-5843-4d66-a39d-3e12b6fa76f1">
                            Privacy Policy
                        </a>
                    </p>
                </div>
                <div className="small m-3">
                    <p>&#169; {getYear(new Date())} Labrador Sports LLC, all rights reserved</p>
                </div>
                <div>
                    <span className="social-icon">
                        <a href="https://www.facebook.com/LacrosseLab" target="_blank" rel="noopener noreferrer">
                            <img src={FacebookLogoWhite} alt="Facebook" />
                        </a>
                    </span>
                    <span className="social-icon">
                        <a href="https://twitter.com/lacrosse_lab?lang=en" target="_blank" rel="noopener noreferrer">
                            <img src={TwitterLogoWhite} alt="Twitter" />
                        </a>
                    </span>
                    <span className="social-icon">
                        <a
                            href="https://www.youtube.com/channel/UCnDsmzWjusDL_Rsth8Hs5Qw"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img src={YouTubeLogoWhite} alt="YouTube" />
                        </a>
                    </span>
                    <span className="social-icon">
                        <a
                            href="https://www.instagram.com/lacrosselab_sports/?hl=en"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img src={InstagramLogoWhite} alt="Instagram" />
                        </a>
                    </span>
                </div>
            </div>
        </section>
    );
};

export default Footer;
